export default __webpack_public_path__ + "logo.cb422eb477e06be9f6d49dc3c55c38d9.png";